import React from 'react';
import './index.css';

class Footer extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (<footer class="Plaas-footer">©Stake Technologies, inc.</footer>);
    }
}

export default Footer;